<template>
  <div>
    <h2>
      <span class="mname">{{ month.name }}</span>
    </h2>
    <div class="days">
      <div v-for="day in days"
        :key="day.key"
        :class="day.classes">
        {{ day.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"MonthYearItem",
  props:["month","daysOfWeek","days","today"]
};
</script>

<style lang="scss" scoped>

.month {
  margin-bottom: 16px;
}

.day.today{
  background-color: #2650e7;
  color: white;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.weekday {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  font-size: 12px;
  color: #999;
  font-weight: 600;
}

h2{
  font-size: 13px;
  font-family: "Montserrat";
}

.mname{
  text-transform: capitalize;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.day {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 13px;
  border-radius: 50%;
  font-size: 9px;
  color: #666;
  font-weight: 600;
  cursor: pointer;
}

.day.today{
  background-color: #2650e7;
  color: white;
}

.empty {
  background-color: transparent;
  color: #ccc;
}
</style>
